import Link from "next/link";
import { ROUTE } from "@/route/app_routes.js";

/**
 * The "Ready to start learning for free?" banner used across ~8 different pages (Home, Blog,
 * BlogDetails, FAQ, Privacy, Terms, event details, ticket-buy). Previously this relied on each
 * caller wrapping it in the legacy theme's `.rbt-callto-action.rbt-cta-default.style-4` classes
 * plus a per-page margin-top utility -- and that legacy style's decorative thumbnail image was
 * absolutely positioned, anchored to the BOTTOM of its container (`position: absolute; left: 0;
 * bottom: 0`), so it could overflow past the TOP of the section and visually overlap whatever
 * content sat directly above it, no matter what margin-top the caller applied (margin only
 * moves the box itself, not an absolutely-positioned child escaping it). That's exactly the bug
 * the user reported ("overlapping with Keep exploring", reported as happening on every page this
 * appears on, which checked out -- all 8 call sites shared the same fragile pattern).
 *
 * Fix: this component is now fully self-contained. It owns its own section wrapper, its own
 * guaranteed spacing (so no caller can under-margin it again), and has no absolutely-positioned
 * decoration that can escape its bounds -- `overflow: hidden` on the card plus everything
 * decorative confined with inset/percentage positioning within it. Callers now just render
 * `<CallToActionOne />` directly, no wrapper div needed.
 */
const CallToActionOne = () => {
  return (
    <section className="rbt-cta-v2">
      <div className="container">
        <div className="rbt-cta-v2__card">
          <div className="rbt-cta-v2__glow rbt-cta-v2__glow--a" aria-hidden="true" />
          <div className="rbt-cta-v2__glow rbt-cta-v2__glow--b" aria-hidden="true" />

          <div className="rbt-cta-v2__content">
            <span className="rbt-cta-v2__eyebrow">Free, structured tech education</span>
            <h2 className="rbt-cta-v2__title">Ready to start learning for free?</h2>
            <p className="rbt-cta-v2__subtitle">
              Join thousands of students building real skills through project-based courses — no tuition, ever.
            </p>

            <Link className="rbt-cta-v2__button" href={ROUTE.register}>
              <span>Join for Free</span>
              <i className="feather-arrow-right"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CallToActionOne;
